import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=b4f35d9e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4f35d9e')) {
      api.createRecord('b4f35d9e', component.options)
    } else {
      api.reload('b4f35d9e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=b4f35d9e&", function () {
      api.rerender('b4f35d9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2a7wQ6dhbMo6h/JS/pricehelp.vue"
export default component.exports